export interface PainPoint {
  title: string
  body: string
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 TOO MUCH THEORY. NOT ENOUGH VISUAL UNDERSTANDING.',
    body: "Angle of attack? Airspace classifications? Instrument indications? Aircraft systems? Reading explanations isn't always enough. Some aviation concepts become much clearer when you can actually see how they work.",
  },
  {
    title: '⚠️ YOU KNOW THE TERMINOLOGY—BUT CAN YOU EXPLAIN IT?',
    body: "Memorizing aviation definitions doesn't automatically mean understanding the principles behind them. Without visual connections, interpreting instruments, navigation information, and flight concepts can remain challenging.",
  },
  {
    title: '📚 YOUR AVIATION STUDY MATERIALS ARE EVERYWHERE',
    body: "Flight manuals, instrument diagrams, aeronautical charts, weather reports, aircraft illustrations, and study notes. The information exists—but it's scattered across different resources when you're trying to connect everything.",
  },
  {
    title: '😩 STOP REBUILDING YOUR STUDY RESOURCES FROM SCRATCH',
    body: 'Searching for cockpit diagrams, comparing instrument indications, and organizing technical explanations takes time. Study with one structured visual system that brings essential private pilot knowledge together.',
  },
]
